import * as echarts from 'echarts';
import { useEffect, useRef } from "react";

const propertyOulined = (xAxis: any, series: any) => {
    return {
        tooltip: {
            trigger: 'item',
        },
        grid: {
            top: 0,
            right: '20px',
            bottom: 0
        },
        xAxis: {
            ...xAxis,
            show: false,
        },
        yAxis: {
            type: 'category',
            axisLabel: { show: false },
            axisTick: { show: false },
            axisLine: { show: false, },
            name: '',
        },
        series
    }
}

interface IProps {
    xAxis: any
    series: any
}

const ChartFishGroups: React.FC<IProps> = ({ xAxis, series }) => {
    const fishgroupsRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (fishgroupsRef.current && series.length > 0) {
            const existInstance = echarts.getInstanceByDom(fishgroupsRef.current)
            if (existInstance) echarts.dispose(fishgroupsRef.current)
            fishgroupsRef.current.style.height = series.length > 0 ? `30px` : `2px`;
            const fishgroupsChart = echarts.init(fishgroupsRef.current);
            fishgroupsChart.setOption(propertyOulined(xAxis, series), true);
        }
    }, [series, xAxis]);

    return <div ref={fishgroupsRef} style={{ height: `2px`, width: '100%' }} />
}

const ChartUnits: React.FC<IProps> = ({ xAxis, series }) => {
    const unitsRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (unitsRef.current && series.length > 0) {
            const existInstance = echarts.getInstanceByDom(unitsRef.current)
            if (existInstance) echarts.dispose(unitsRef.current)
            unitsRef.current.style.height = series.length > 0 ? `30px` : `2px`;
            const unitsChart = echarts.init(unitsRef.current);
            unitsChart.setOption(propertyOulined(xAxis, series), true);
        }
    }, [series, xAxis]);

    return <div ref={unitsRef} style={{ height: `2px`, width: '100%' }} />
}

export { ChartFishGroups, ChartUnits };
